import dynamic from 'next/dynamic';
import { ArrowCircleRight } from '@phosphor-icons/react';
import { AcfButton } from '@/types';

const Link = dynamic(() => import('./Link'));

const linkStyle = {
  '> svg': {
    color: 'success.700',
    marginRight: 2,
  },
};
const ArrowButton = ({ link, title }: AcfButton) => {
  if (link) {
    return (
      <Link
        href={link.url}
        display="inline-flex"
        alignItems="center"
        sx={linkStyle}
      >
        <ArrowCircleRight size="24px" />
        {title}
      </Link>
    );
  }
  return null;
};

export default ArrowButton;
